// modules/website/components/VideoComponent.tsx - Player de Vídeo

import React from 'react';
import { VideoData } from '@/types';

interface Props {
  data: VideoData;
  settings?: any;
}

export const VideoComponent: React.FC<Props> = ({ data, settings }) => {
  const {
    youtubeId = '',
    title,
    autoplay = false,
    showControls = true,
    width = '100%'
  } = data || {};

  // Construir URL do embed
  const embedUrl = `https://www.youtube.com/embed/${youtubeId}?${new URLSearchParams({
    autoplay: autoplay ? '1' : '0',
    controls: showControls ? '1' : '0',
    rel: '0',
    modestbranding: '1'
  }).toString()}`;

  return (
    <div 
      className="py-8 px-6"
      style={{ backgroundColor: settings?.backgroundColor }}
    >
      <div 
        className="max-w-4xl mx-auto"
        style={{ width }}
      >
        {title && (
          <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
            {title}
          </h3>
        )}
        <div className="aspect-video bg-gray-900 rounded-xl overflow-hidden shadow-2xl">
          <iframe
            src={embedUrl}
            title={title || 'Vídeo'}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className="w-full h-full"
          />
        </div>
      </div>
    </div>
  );
};
